import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import "./AdminPanel.css";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) nav("/admin");
  }, [ready, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Anmeldung fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-[100dvh] flex items-center justify-center px-5">
      <form onSubmit={submit} className="bg-canvas border border-stone-800 rounded-2xl p-7 w-full max-w-sm" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-10 w-10 rounded-full bg-brass/15 border border-brass/40 flex items-center justify-center text-brass">
            <KeyRound size={18} />
          </div>
          <div>
            <h1 className="font-serif-display text-brass text-xl">Adminbereich</h1>
            <p className="font-mono-meta text-[10px] text-stone-500 uppercase tracking-widest">TattooGen Verwaltung</p>
          </div>
        </div>
        <div className="space-y-3">
          <div>
            <Label className="text-stone-300 text-xs">E-Mail</Label>
            <Input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-surface border-stone-700 mt-1" />
          </div>
          <div>
            <Label className="text-stone-300 text-xs">Passwort</Label>
            <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-surface border-stone-700 mt-1" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-button" className="cta-brass w-full h-11 rounded-full font-mono-meta text-sm uppercase tracking-widest font-semibold disabled:opacity-60">
            {loading ? "Anmelden…" : "Anmelden"}
          </button>
        </div>
      </form>
    </div>
  );
}
